import React from "react";

import { connect } from "react-redux";

import { Link } from "react-router-dom";
import logo from "logo.png";
import "./signin.css";
import API from "api";

class ResettingRequest extends React.Component {
  state = {
    email: "",
    error: "",
    message: "",
    submitting: false
  };

  request = e => {
    e.preventDefault();
    this.setState({ submitting: true, error: "" });
    API.resettingRequestPassword({
      email: this.state.email
    })
      .then(response => {
        const { message } = response.data;

        this.setState({
          error: null,
          message:
            message ||
            "Votre demande a été prise en compte, vous allez recevoir un email contenant les inscructions",
          submitting: false
        });
      })
      .catch(error => {
        let message = error.message;
        if (error.response) {
          message = error.response.data.message;
        }
        this.setState({
          error: message,
          submitting: false
        });
      });
  };

  render() {
    const { message, error, submitting } = this.state;
    return (
      <div className=" min-vh-100 d-flex  justify-content-center align-items-center">
        <div className="wrapper fadeInDown">
          <Link to="/publications">
            <img src={logo} alt="logo" className="mb-4" height="100" />
          </Link>
          <div className="formContent">
            <div className="fadeIn first">
              {/* <img
                src="http://danielzawadzki.com/codepen/01/icon.svg"
                id="icon"
                alt="User Icon"
              /> */}
            </div>

            <form
              method="post"
              className="my-3 d-flex flex-column align-items-center px-4"
              onSubmit={this.request}
            >
              {error && <p className="text-danger text-center">{error}</p>}
              {message && <p className="text-success text-center">{message}</p>}
              <input
                type="text"
                className="fadeIn second"
                name="login"
                placeholder="Email"
                onChange={e => {
                  this.setState({ email: e.target.value });
                }}
                disabled={submitting}
              />
              />
              <button
                type="button"
                className="btn btn-ikea btn-block my-4 fadeIn fourth"
                onClick={this.request}
                disabled={submitting}
              >
                Envoyer
              </button>
            </form>
            <div className="formFooter">
              <Link to="/signin" className="underlineHover">
                Connexion
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuth: Boolean(state.security.user)
});
const binActionsToProps = dispatch => ({});
export default connect(mapStateToProps, binActionsToProps)(ResettingRequest);
